import { useContext, Dispatch } from 'react'
import { AppContext } from './AppContext'
import { AppState, Action } from './AppContext.types'

interface AppContextType {
  state: AppState
  dispatch: Dispatch<Action>
}

export const useAppContext = (): AppContextType => useContext(AppContext)
